import * as permissionConsts from "@/consts";

export function filterAccessibleBranchParents(parents, { permissions, myBranches } = {}) {
  if (!parents?.length) {
    return [];
  }

  if (permissions?.has(permissionConsts.BRANCH_TOP_VIEW)) {
    return parents;
  }

  if (!myBranches?.length) {
    return [];
  }

  const minLevel = Math.min(...myBranches.map((branch) => branch.level));

  return parents.filter((parent) => parent.parent_level >= minLevel);
}

export function mapBranchParentsToBreadcrumbItems(parents) {
  return parents.map((parent) => ({
    text: parent.parent_name,
    to: {
      name: "BranchesSubLayer",
      params: { branchID: parent.parent_id },
    },
  }));
}
